import { Home, FileText, Scale, Building, Receipt, Briefcase } from "lucide-react";

const Services = () => {
  const services = [
    {
      icon: Home,
      title: "Property Registration",
      description: "Complete registration services for sites, plots, and apartments with end-to-end documentation support.",
      features: ["Site Registration", "Plot Registration", "Apartment Registration", "Freehold Conversion"]
    },
    {
      icon: FileText,
      title: "Sale Deeds & Agreements",
      description: "Professional drafting and execution of sale deeds, purchase agreements, and legal contracts.",
      features: ["Sale Deed Drafting", "Purchase Agreements", "Gift Deeds", "Lease Agreements"]
    },
    {
      icon: Scale,
      title: "Legal Documentation",
      description: "Comprehensive legal documentation services ensuring compliance with all regulatory requirements.",
      features: ["Title Verification", "Encumbrance Certificates", "Property Documents", "Legal Compliance"]
    },
    {
      icon: Briefcase,
      title: "Property Legal Consultancy",
      description: "Expert legal advice on property matters, disputes, and regulatory compliance.",
      features: ["Legal Advisory", "Dispute Resolution", "Due Diligence", "Title Search"]
    },
    {
      icon: Receipt,
      title: "Stamp Duty Guidance",
      description: "Complete assistance with stamp duty calculation, payment, and registration procedures.",
      features: ["Duty Calculation", "Payment Processing", "Documentation", "Compliance Check"]
    },
    {
      icon: Building,
      title: "Registration Process Support",
      description: "End-to-end guidance through the entire property registration process with sub-registrar office.",
      features: ["Document Preparation", "Office Coordination", "Registration Support", "Post-Registration Services"]
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block bg-emerald-50 rounded-full px-6 py-2 mb-6">
            <span className="text-emerald-700 font-semibold text-sm tracking-wide">OUR SERVICES</span>
          </div>
          
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            Comprehensive Property & Legal Services
          </h2>
          
          <p className="text-lg text-slate-600">
            From property registration to legal consultancy, we provide complete solutions for all your property documentation needs.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl p-8 shadow-md hover:shadow-2xl transition-all duration-300 border border-slate-100 hover:border-emerald-200 hover:-translate-y-2"
            >
              <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-xl p-4 inline-block mb-6 group-hover:from-emerald-600 group-hover:to-emerald-700 transition-all duration-300">
                <service.icon className="text-emerald-700 group-hover:text-white transition-colors" size={32} />
              </div>
              
              <h3 className="text-xl font-bold text-slate-900 mb-3">
                {service.title}
              </h3>
              
              <p className="text-slate-600 mb-6 leading-relaxed">
                {service.description}
              </p>

              <ul className="space-y-2">
                {service.features.map((feature, idx) => (
                  <li key={idx} className="flex items-center gap-2 text-sm text-slate-600">
                    <div className="w-1.5 h-1.5 rounded-full bg-emerald-600"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <a 
            href="tel:+918217026707"
            className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-600 to-emerald-700 text-white px-8 py-4 rounded-lg font-bold text-lg hover:from-emerald-700 hover:to-emerald-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105"
          >
            Get Expert Consultation
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
